import React, { useEffect, useState } from "react";
import "./Totalorder.css";
const Totalorder = ({ searchData, setTotalCallreceived , isFetchButtonClicked}) => {
  const [AiOrder, setAiOrder] = useState(0);
  const [NonAiOrder, setNonAiOrder] = useState(0);
  const [telephonyOrder, setTelephonyOrder] = useState(0);
  const [webOrder, setWebOrder] = useState(0);
  const [unreachable, setUnreachable] = useState(0);
  const [totalCalls, setTotalCalls] = useState(0)
  const [AiPercent, setAiPercent] = useState(0)
  const [OperatorPercent,setOperatorPercent ] = useState(0)
  const [trashPercent, setTrashPercent] = useState(0)
  const [totalOrder, setTotalOrder] = useState(0)
  let totalWebOrder = 0;
  let totalTelephonyOrder = 0;
  // useEffect(() => {}, [searchData]);

  // console.log("Total Orders", searchData);

  //NOTE:- This useEffect runs whenever searchData updates
  // with the help of this useEffect we are calculating the aiOrder and NonAiorder and updating the AiOrder and NonAiOrder state
  useEffect(() => {
    // NOTE: - Here We are updaing the state
    setAiOrder(searchData.total_ai_orders);
    setNonAiOrder(searchData.total_operator_orders);
    
    setWebOrder(searchData.WEBBOT);
    setTelephonyOrder(searchData.TELEPHONY);
    setUnreachable(searchData.total_trash_calls);
    setTotalCalls(searchData.total_calls)
    setAiPercent(searchData.ai_orders_percentage)
    setOperatorPercent(searchData.operator_orders_percentage)
    setTrashPercent(searchData.trash_call_percentage)
    setTotalOrder(searchData.total_orders)

    // return()=>{
    //   setAiOrder(0)
    //   setNonAiOrder(0)
    //   setTelephonyOrder(0)
    //   setWebOrder(0)
    //   setUnreachable(0)
    //   setTotalCalls(0)
    // }
  }, [searchData]);



useEffect(()=>{
  console.info("Fetching ....", isFetchButtonClicked)
if(isFetchButtonClicked){
  
  setAiOrder(0)
  setNonAiOrder(0)
  setTelephonyOrder(0)
  setWebOrder(0)
  setUnreachable(0)
  setTotalCalls(0)
  setAiPercent(0)
  setOperatorPercent(0)
  setTrashPercent(0)
  setTotalOrder(0)

}

},[isFetchButtonClicked])


  // console.log("AiOrder", AiOrder);
  // console.log("NonAiorder", NonAiOrder);
  useEffect(() => {}, [AiOrder, NonAiOrder]);

  return (
    <div className="totalorder">
      <div className="totalOrder__details">
        <div className="totalOrder__description">
          <center className="totalOrder__Text">Total Orders</center>
          <p>AI Success Orders</p>
          <p>Operator Orders</p>
          <p>
            <span style={{ fontSize: "17px", borderBottom: "2px solid" }}>
              Telephony Orders
            </span>
            <span style={{ marginLeft: "15px", fontSize: "17px" }}>
              {telephonyOrder}
            </span>
          </p>
        </div>
        <div className="totalOrder__numberDetails">
          <center className="totalOrder__number">{totalOrder}</center>

          <p>
            {AiOrder}
            {(AiOrder + NonAiOrder) !=0  &&
            <span style={{ marginLeft: "15px", fontWeight: "800" }}>
              {(AiPercent).toFixed(2)}%
            </span>
            }
          </p>

          <p>
            {NonAiOrder}
            { (AiOrder + NonAiOrder) !=0 &&
              <span style={{ marginLeft: "15px", fontWeight: "800" }}>
              {(OperatorPercent).toFixed(2)}%
            </span>

            }
          </p>

          <p>
            <span style={{ fontSize: "17px", borderBottom: "2px solid" }}>
              Web Orders{" "}
            </span>
            <span
              style={{
                marginLeft: "15px",
                fontSize: "17px",
              }}
            >
              {webOrder}
            </span>
          </p>
        </div>
      </div>

      <div className="totalOrder__callRecord">
        <div className="callRecord__text">
          <p>Total Calls (Received)</p>
          <p>Unable to reach the callers back </p>
        </div>
        <div className="callRecord__numbers" style={{ marginLeft: "20px" }}>
          <p>{totalCalls}</p>
          <p>
            {unreachable}
            {totalCalls!=0 && <span style={{ fontSize: "13px", marginLeft: "15px" }}>
              {(trashPercent).toFixed(2)}%
            </span>
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default Totalorder;
